import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Activity } from 'lucide-react';
import PageHeader from '../../components/PageHeader';
import LoadingSpinner from '../../components/LoadingSpinner';
import EmptyState from '../../components/EmptyState';
import WeightChart from '../../components/WeightChart';
import * as progressApi from '../../api/progress.api';
import { errorMessage } from '../../api/client';

// Customer-facing progress timeline + weight chart.

function MyProgress() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      try {
        const list = await progressApi.myProgress();
        if (!cancelled) setEntries(list || []);
      } catch (e) {
        if (!cancelled) toast.error(errorMessage(e));
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <>
      <PageHeader title="My progress" subtitle="Your weight, lab results, and clinic uploads in one timeline." />

      {entries.length === 0 ? (
        <EmptyState
          icon={Activity}
          title="No progress entries yet"
          description="Once you visit your clinic, your before/weekly/after weigh-ins will show here."
        />
      ) : (
        <>
          <div className="card">
            <WeightChart entries={entries} />
          </div>

          <div className="card" style={{ marginTop: 'var(--s-4)' }}>
            <h3>Timeline</h3>
            <table className="table">
              <thead><tr><th>When</th><th>Type</th><th>Week</th><th>Weight</th><th>BMI</th><th>Notes</th></tr></thead>
              <tbody>
                {entries.map((e) => (
                  <tr key={e._id}>
                    <td>{new Date(e.recordedAt || e.createdAt).toLocaleDateString()}</td>
                    <td><span className="badge">{e.kind}</span></td>
                    <td>{e.weekIndex || 0}</td>
                    <td>{e.weightKg ? `${e.weightKg} kg` : '—'}</td>
                    <td>{e.bmi || '—'}</td>
                    <td className="muted text-sm">{e.labTestName ? `${e.labTestName}: ${e.labValue}` : e.notes}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}

export default MyProgress;
